import useAIConfigs from "@/hooks/useAIConfigs";
import useApi from "@/hooks/useApi";
import { PrimaryBlueButton, Severity } from "@velaro/velaro-component-lib";
import React, { useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AIConfiguration, AzureIndex } from "../types";
import CreateIndexModal from "./CreateIndexModal";
import useAzureIndexes from "@/hooks/useAzureIndexes";
import useToastAlert from "@/hooks/useToastAlert";
import useSubscriptions from "@/hooks/useSubscriptions";
import { sub } from "date-fns";
import { use } from "i18next";

export default function CreateIndexButton() {
  const [tempSearchIndex, setTempSearchIndex] = React.useState<AzureIndex>({
    id: 0,
    name: "",
    searchSize: 1,
    siteId: 0,
    type: "",
    semanticSearchEnabled: false
  });
  const { azureIndexes, loading, add } = useAzureIndexes();
  const [showCreateModal, setShowCreateModal] = React.useState(false);
  const { subscription } = useSubscriptions();
  const [enableCreateIndex, setEnableCreateIndex] = React.useState(
    subscription ? azureIndexes.length < subscription.maxIndexCount : false
  );
  const api = useApi();
  const ToastAlert = useToastAlert();

  async function createIndex(index: AzureIndex) {
    if (index.searchSize > 9 || index.searchSize <= 0) {
      ToastAlert.displayToast(
        Severity.Error,
        "Search size must be between 1 and 9"
      );
      return;
    }
    const response = await api.messaging.post("AzureIndexes/CreateIndex", {
      name: index.name,
      searchSize: index.searchSize,
      semanticSearchEnabled: index.semanticSearchEnabled,
      type: index.type
    });
    const result = (await response.json()) as AzureIndex;
    if (response.status !== 200) {
      ToastAlert.displayToast(Severity.Error, response.statusText);
      return;
    }
    add(result);
    clearSearchModal();
  }

  function clearSearchModal() {
    setTempSearchIndex({
      id: 0,
      name: "",
      searchSize: 1,
      siteId: 0,
      type: "",
      semanticSearchEnabled: false
    });
    setShowCreateModal(false);
  }

  useEffect(() => {
    setEnableCreateIndex(
      subscription ? azureIndexes.length < subscription.maxIndexCount : false
    );
  }, [azureIndexes, subscription]);

  return (
    <>
      <PrimaryBlueButton
        label="+ Create Training Index"
        onClick={() => {
          setShowCreateModal(!showCreateModal);
        }}
        disabled={!enableCreateIndex}
      />

      {showCreateModal && (
        <CreateIndexModal
          tempSearchIndex={tempSearchIndex}
          clearSearchModal={clearSearchModal}
          createIndex={createIndex}
        />
      )}
    </>
  );
}
